import React, { Suspense } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import routes from '../../routes';
import LoadingSpinner from './LoadingSpinner';

const loading = <LoadingSpinner />;

const AppContent = () => {
  return (
    <div className="flex min-h-screen min-w-full flex-col">
      <Suspense fallback={loading}>
        <Routes>
          {routes.map((route, idx) =>
            route.children ? (
              <Route key={idx} path={route.path} element={<route.element />}>
                <Route index element={<Navigate to={route.children[0].path} replace />} />
                {route.children.map((child, childIdx) => (
                  <Route key={route.path + childIdx} path={child.path} element={<child.element />} />
                ))}
              </Route>
            ) : (
              <Route key={idx} path={route.path} element={<route.element />} />
            ),
          )}
          <Route path="*" element={<Navigate to="/404" />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default React.memo(AppContent);
